import { ResponseType } from 'types/response.d';
import { BaseUserRequest, UserType, ChangePasswordRequest } from 'types/entities/users.d';
import { get, put } from './axios';

const url = `/my-account`;

export const updateUserProfile = (
  request: BaseUserRequest,
  language: string
): Promise<ResponseType<UserType>> => put(`${url}`, request, { headers: { language } });

export const updateUserPassword = (
  request: ChangePasswordRequest
): Promise<ResponseType<UserType>> => put(`${url}/change-password`, request);

export const cancelVerifyEmail = (): Promise<ResponseType<boolean>> =>
  put(`${url}/verifying-email/cancel`);

export const resendVerificationEmail = (language: string): Promise<ResponseType<boolean>> =>
  put(`${url}/verifying-email/resend`, null, { headers: { language } });

export const getUserVerifyingEmail = (): Promise<{ data: string }> => {
  return get(`${url}/verifying-email`);
};
